// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const brokerMarketPulsesRequest = (accountId) => ({
    type: actionTypes.FETCH_BROKER_MARKET_PULSES_REQUEST,
    payload: {
        accountId
    }
})

const brokerMarketPulsesSuccess = (data) => ({
    type: actionTypes.FETCH_BROKER_MARKET_PULSES_SUCCESS,
    payload: {
        data: data.noticias || []
    }
})

const brokerMarketPulsesFailure = (error) => ({
    type: actionTypes.FETCH_BROKER_MARKET_PULSES_FAILURE,
    payload: {
        error
    }
})

const requestMarketPulses = (params) => (dispatch, getState) => {
    const immMarketsPulses = getState().brokerMarketsPulses;
    // const hasPulses = immMarketsPulses.get('byOrder').size > 0;
    const hasPulseById = !!immMarketsPulses.getIn(['byId', params.id]);

    if ( hasPulseById ){
        return Promise.resolve();
    }

    const requestData = {
        query: {
            BMCategory: 'pulsos',
            inferior: params.start || 0,
            superior: params.end || 5
        }
    };

    if (params.id){
        requestData.query.story_id = params.id;
    }

    dispatch(brokerMarketPulsesRequest());
    return APIGet({
        dispatch,
        endpoint: 'marketWFGNews',
        url: apiURLBuilder.getURL('marketWFGNews'),
        params: requestData
    })
    .then(response => dispatch(brokerMarketPulsesSuccess(response)))
    .catch(response => dispatch(brokerMarketPulsesFailure(response.error)));
}

module.exports = {
    requestMarketPulses
}
